// extracted by mini-css-extract-plugin
export default {"spreadsheet_main":"SpreadsheetGuide_spreadsheet_main__Lfyn+"};